var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 0H5.2C3.82087 0 2.49823 0.547855 1.52304 1.52304C0.547855 2.49823 0 3.82087 0 5.2V26.8C0 27.4829 0.134502 28.1591 0.395826 28.79C0.657151 29.4208 1.04018 29.9941 1.52304 30.477C2.00591 30.9598 2.57915 31.3429 3.21005 31.6042C3.84094 31.8655 4.51713 32 5.2 32H26.8C27.4829 32 28.1591 31.8655 28.79 31.6042C29.4208 31.3429 29.9941 30.9598 30.477 30.477C30.9598 29.9941 31.3429 29.4208 31.6042 28.79C31.8655 28.1591 32 27.4829 32 26.8V5.2C32 4.51713 31.8655 3.84094 31.6042 3.21005C31.3429 2.57915 30.9598 2.00591 30.477 1.52304C29.9941 1.04018 29.4208 0.657151 28.79 0.395826C28.1591 0.134502 27.4829 0 26.8 0ZM23.68 17.68C23.68 17.76 23.68 17.84 23.52 17.92L8.56 25.44C8.48 25.52 8.32 25.36 8.32 25.28V21.44C8.32 21.36 8.32 21.28 8.4 21.28L19.28 15.84L8.4 10.32C8.32 10.32 8.32 10.24 8.32 10.16V6.32C8.32 6.24 8.48 6.08 8.56 6.16L23.52 13.68C23.5697 13.7173 23.61 13.7656 23.6378 13.8211C23.6655 13.8767 23.68 13.9379 23.68 14V17.68Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplunk);
export default __webpack_public_path__ + "static/media/Splunk.c535e3ab10ed6682629d470853f17224.svg";
export { ForwardRef as ReactComponent };